import { render } from "./CheckboxInput.vue?vue&type=template&id=db771cf8"
import script from "./CheckboxInput.vue?vue&type=script&lang=ts"
export * from "./CheckboxInput.vue?vue&type=script&lang=ts"
script.render = render

export default script